import CampaignComponentVariable from "src/shared/store/campaign-component/variable/model/CampaignComponentVariable";
export const isCampaignComponentPartnerEnumVariableResponse = (response) => {
    return (response.type === "PARTNER_ENUM" &&
        "webhook_id" in response &&
        "options" in response);
};
export const isCampaignComponentPartnerEnumVariable = (variable) => {
    return variable instanceof CampaignComponentPartnerEnumVariable;
};
export class CampaignComponentPartnerEnumVariable extends CampaignComponentVariable {
    constructor(variableResponse, context) {
        super(variableResponse, context);
        this.webhook_id = variableResponse.webhook_id;
        this.options = variableResponse.options;
    }
    getWebhookId() {
        return this.webhook_id;
    }
    getOptions() {
        return this.options;
    }
}
